import styled from "@emotion/styled";
import { SHELL_FOOTER_HEIGHT } from "../Navigation/Sidebar.styles";

/* Height is pinned so this bar and the sidebar's collapse control read as one strip across the
   bottom of the shell. The mobile block below drops the fixed height, because the copyright and
   the links stack there and would be clipped by it. */
export const FooterWrapper = styled.footer`
  height: ${SHELL_FOOTER_HEIGHT};
  padding: 0 ${({ theme }) => theme.spacing.xl};
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.border};
  display: flex;
  flex-direction: column;
  align-items: center; /* <-- ДОДАЛИ ЦЕНТРУВАННЯ ДЛЯ МОБІЛКИ */
  gap: ${({ theme }) => theme.spacing.md};
  background-color: transparent;

  @media (min-width: 48rem) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: 48rem) {
    height: auto;
    padding: ${({ theme }) => theme.spacing.md};
    text-align: center; /* <-- Щоб довгий текст копірайту центрувався */
  }
`;

export const FooterText = styled.p`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0;
`;

export const FooterLinks = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  flex-wrap: wrap;
  justify-content: center; /* <-- ЦЕНТРУЄМО ПОСИЛАННЯ */

  a {
    font-size: ${({ theme }) => theme.typography.sizes.sm};
    color: ${({ theme }) => theme.colors.textMuted};
    transition: color 0.2s ease;

    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;
